export default defineNuxtRouteMiddleware((to, from) => {
  // console.log('im in middleware')

  if (to.path === '/shows/watch/z0iNx921mmI') {
    // setting the redirect code to '301 Moved Permanently'
    return navigateTo('/shows/watch/2021$z0iNx921mmI', { redirectCode: 301 })
  }
  if (to.path === '/shows/watch/tWHkgANWvqQ') {
    // setting the redirect code to '301 Moved Permanently'
    return navigateTo('/shows/watch/2018$tWHkgANWvqQ', { redirectCode: 301 })
  }
})
